import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { subscriptionsAPIUrls } from '../../subscriptions/data';

interface Licences {
  id: number;
  name: string;
  remaining: number;
  is_infinite: boolean;
}

interface GetLicencesResponse {
  success: boolean;
  data: Licences[];
}

export const getLicences = withLogger(async (companyID: string) => {
  const response = await authServiceAxiosClient.get<GetLicencesResponse>(
    subscriptionsAPIUrls.getLicences + '?cid=' + companyID,
  );

  return response.data?.data ?? [];
});
